import { combineReducers } from 'redux';
import { loginReducer } from './containers/LoginPage';
import { ordersPageReducer } from './containers/OrdersPage';
import { initComponentReducer } from './containers/InitComponent';
import { productsPageReducer } from './containers/ProductsPage';
import { editPageReducer } from './containers/EditPage';
import { orderPageReducer } from './containers/OrderPage';
import { historyPageReducer } from './containers/OrderHistoryPage';
import { adminPageReducer } from './containers/SourcesPage';
import { sourcePageReducer } from './containers/SourcePage';
import { networkPageReducer } from './containers/NetworkPage';
import { operatorsPageReducer } from './containers/OperatorsPharmacistPage';
import { promoCodePageReducer } from './containers/PromoCodePage';
import { reportPageReducer } from './containers/ReportPage';
import { activeUsersReducer } from '../src/components/ActivePharmacistBlock';
import { webStockPageReducer } from './containers/WebStockPage';
import { analogsPageReducer } from './containers/AnalogsPage';
import { settingsPageReducer } from './containers/SettingsPage/index';
import { salesPageReducer } from './containers/SalesPage';
import { moderationPageReducer } from './containers/ModerationPage';
import { loyaltyPageReducer } from './containers/LoyaltyPage';
import { rxGatePageReducer } from './containers/RXGatePage';
import { integrationsPageReducer } from './containers/IntegrationsPage/reducer';
import { settingsPagePharmacyReducer } from './containers/SettingsPagePharmacy';

export default combineReducers({
  loginReducer,
  ordersPageReducer,
  initComponentReducer,
  productsPageReducer,
  editPageReducer,
  orderPageReducer,
  historyPageReducer,
  adminPageReducer,
  sourcePageReducer,
  networkPageReducer,
  operatorsPageReducer,
  reportPageReducer,
  activeUsersReducer,
  promoCodePageReducer,
  webStockPageReducer,
  analogsPageReducer,
  salesPageReducer,
  moderationPageReducer,
  settingsPageReducer,
  settingsPagePharmacyReducer,
  loyaltyPageReducer,
  rxGatePageReducer,
  integrationsPageReducer,
});
